module.exports = __webpack_public_path__ + "static/media/tier-9.3021f10d.jpg";